import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { WithSideAds } from "components/ads";
import { getHashValue } from "utils";

import { RelatedFeed } from "./components/RelatedFeed";

import "./WatchPage.scss";
import "../common.scss";
import { ContentPageSkyscraperEnum } from "../../components/ads/config/units/contentPageSkyscraper";

export const WatchPage = () => {
  const { id } = useParams();
  const rel = getHashValue("rel");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <WithSideAds
      leftAds={[
        ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
      ]}
      rightAds={[
        ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
      ]}
    >
      <div className="page watchPage">
        {id && (
          <RelatedFeed gif={id} rel={rel} className="center" />
        )}
      </div>
    </WithSideAds>
  );
};
